import { baseUrl } from 'scripts/env'

export const getGeoipCountry = async () => {
  const baseApiUrl = baseUrl.replace('partner', 'api');

  try {
    const response = await fetch(`${baseApiUrl}/1/country`);

    if (!response.ok) {
      throw new Error();
    }

    return response.headers.get('Gcc');
  } catch (err) {
    return null;
  }
};


// WEBPACK FOOTER //
// ./src/scripts/geoip.js